import * as types from "../constants/action-types";

export function puzzleSolved(puzzle) {
  return {
    type: types.PUZZLE_SOLVED,
    puzzle
  };
}

export function skipPuzzles() {
  return {
    type: types.SKIP_PUZZLES
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js